import React from 'react';
import './copyright.scss'
export function Copyright () {

  const getFullYear = () => {
    const date = new Date();
    return date.getFullYear();
  }

  return (
    <p className='px-4 copyright'> Copyright © { getFullYear() } Arezzo&Co. Todos os direitos reservados. </p>
  )
;}
